import { BaseApi } from './BaseApi';
export class ChannelApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getChannel(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('channel'),
            params: {
                id,
            },
        });
    }
    getAllChannels() {
        return this.providers.makeRequest({
            route: this.buildRoute('channels'),
        });
    }
    deleteChannel(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('channel'),
            method: 'DELETE',
            params: {
                id,
            },
        });
    }
    deleteAllChannels() {
        return this.providers.makeRequest({
            route: this.buildRoute('channels'),
            method: 'DELETE',
        });
    }
    updateChannel(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('channel'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    createChannel(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('channel'),
            method: 'POST',
            data,
        });
    }
    setPrimaryChannelFlow(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('channel/setPrimaryFlow'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    getSuggestedChannels() {
        return this.providers.makeRequest({
            route: this.buildRoute('channels/suggested'),
        });
    }
}
//# sourceMappingURL=channelApi.js.map